import {appendQueryString} from "@pg-mono/request";

import {resimoApiToken} from "../constants";
import {yslabApi} from "./yslab_api";

export const yslabInvestmentsApi = yslabApi.injectEndpoints({
    endpoints: (builder) => ({
        getYslabPropertyList: builder.query<{data: YslabProperty[]}, {investmentId?: number}>({
            query: ({investmentId}) => {
                return {
                    url: appendQueryString(`investment/${investmentId}/apartments`, {token: resimoApiToken})
                };
            }
        })
    })
});

export const {useGetYslabPropertyListQuery} = yslabInvestmentsApi;

export interface YslabProperty {
    id: number;
    name: string;
    buildingNumber: null;
    status: string;
}
import {appendQueryString} from "@pg-mono/request";

import {resimoApiToken} from "../constants";
import {yslabApi} from "./yslab_api";

export const yslabInvestmentsApi = yslabApi.injectEndpoints({
    endpoints: (builder) => ({
        getYslabPropertyList: builder.query<{data: YslabProperty[]}, {investmentId?: number}>({
            query: ({investmentId}) => {
                return {
                    url: appendQueryString(`investment/${investmentId}/apartments`, {token: resimoApiToken})
                };
            }
        })
    })
});

export const {useGetYslabPropertyListQuery} = yslabInvestmentsApi;

export interface YslabProperty {
    id: number;
    name: string;
    buildingNumber: null;
    status: string;
}
